import { createCustomSlice } from 'core/utils';
import i18n from 'i18nextInstance';
import orderBy from 'lodash/orderBy';
import { parseSelect } from 'shared/utils';

const initialState = {
    areas: [],
    areasError: '',
    areasLoading: false,
    areasStatus: '',
    campaignTypes: [],
    campaignTypesLoading: false,
    cities: [],
    citiesLoading: false,
    companies: [],
    companiesError: {},
    companiesLoading: false,
    companiesStatus: '',
    controlTypes: [],
    controlTypesDetail: [],
    controlTypesDetailLoading: false,
    controlTypesLoading: false,
    controls: [],
    controlsError: {},
    controlsLoading: false,
    controlsStatus: '',
    costCenters: [],
    costCentersError: '',
    costCentersLoading: false,
    costCentersStatus: '',
    coverages: [],
    districts: [],
    districtsLoading: false,
    enrollments: [],
    offices: [],
    patients: [],
    patientsLoading: false,
    plans: [],
    polyOffices: [],
    polyOfficesLoading: false,
    positions: [],
    positionsError: {},
    positionsLoading: false,
    positionsStatus: '',
    professionals: [],
    professionalsLoading: false,
    provinces: [],
    provincesLoading: false,
    riskAgentTypes: [],
    riskAgentTypesLoading: false,
    riskAgents: [],
    riskAgentsError: {},
    riskAgentsLoading: false,
    riskAgentsSelected: {},
    specialties: [],
    specialtiesLoading: false,
    specialtiesRegistrationError: {},
    specialtiesSuccess: false,
    symptoms: [],
    vaccineDoses: [],
    vaccineDosesLoading: false,
    vaccines: [],
    vaccinesLoading: false,
    workplaces: [],
    workplacesError: {},
    workplacesLoading: false,
    workplacesStatus: ''
};

const optionSlice = createCustomSlice({
    initialState,
    name: 'option',
    reducers: {
        setOptionCompanies (state, { payload }) {
            state.companies = orderBy(payload, 'name');
        },
        setOptionControls (state, { payload }) {
            state.controls = orderBy(payload, 'name');
        },
        setOptionPositions (state, { payload }) {
            state.positions = orderBy(payload, 'name');
        },
        setOptionRiskAgentTypes (state, { payload }) {
            state.riskAgentTypes = orderBy(payload, 'name');
        }
    },
    saga: [
        'createPolyOffice',
        'createSpecialty',
        'deleteControl',
        'deletePolyOffice',
        'deleteSpecialty',
        'getAreas',
        'getCampaignTypes',
        'getCities',
        'getCompanies',
        'getControlTypes',
        'getControlTypesDetail',
        'getControls',
        'getCostCenters',
        'getCoverages',
        'getDistricts',
        'getEnrollments',
        'getOffices',
        'getPatients',
        'getPlans',
        'getPolyOffices',
        'getPositions',
        'getProfessionals',
        'getProvinces',
        'getRiskAgentTypes',
        'getRiskAgent',
        'getRiskAgents',
        'getSpecialties',
        'getSymptoms',
        'getVaccineDoses',
        'getVaccines',
        'getWorkplaces',
        'updateCampaignType',
        'updatePolyOffice',
        'updateSpecialty',
        'upsertArea',
        'upsertCompany',
        'upsertControl',
        'upsertCostCenter',
        'upsertPosition',
        'upsertRiskAgent',
        'upsertWorkplace'
    ]
});

export const parseControl = control => {
    const { id, name, type } = control;
    return ({
        ...control,
        control_type_id: type?.id,
        control_type_name: type?.name,
        label: name,
        value: id
    });
};

export const parseControls = list => list.map(c => parseControl(c));

export const parsePatients = list => orderBy(list.map(patient => {
    const {
        first_name,
        id,
        identification,
        last_name
    } = patient;
    return ({
        ...patient,
        label: `${ identification } - ${ last_name }, ${ first_name }`,
        patient_id: id,
        value: id
    });
}), ['last_name', 'first_name']);

export const parseProfessionals = list => [{
    label: i18n.t('Todos los profesionales'),
    value: 0
}, ...orderBy(list.map(professional => {
    const { first_name, id, last_name, specialties } = professional;
    return ({
        ...professional,
        label: `${ last_name }, ${ first_name }`,
        specialties: specialties.map(({ id }) => id),
        specialty_names: specialties.map(({ name }) => name),
        value: id
    });
}), 'label')];

export const parseRiskAgent = riskAgent => ({
    ...riskAgent,
    label: `${ riskAgent?.name }${ riskAgent?.code ? ` - ${ riskAgent.code }` : '' }`,
    type_name: riskAgent?.type?.name,
    value: riskAgent?.id
});

export const parseSpecialties = list => [{
    label: i18n.t('Todas las especialidades'),
    value: 0
}, ...orderBy(parseSelect(list), 'label')];

export const parseWorkplaces = list => orderBy(list.map(workplace => {
    const { id, name } = workplace;
    return ({
        ...workplace,
        label: name,
        value: id
    });
}), ['name']);

export const optionActions = optionSlice.actions;

export default optionSlice.reducer;
